import React from "react";
import { Link } from "react-router-dom";
import "../css/main.scss";
import productData from "../Datas/productData";
import { formatMoney } from "../config/store";

const sections = [
  { id: 1, bannerImg: "/img/editorial/banner-01.png", bannerTitle: "Small things, bright days", bannerDesc: "Original gifts with colour, character and everyday usefulness.", bannerBtn: "Shop gifts", sectionTitle: "Harbour-inspired finds", sectionLinkText: "Shop now", boxBg: "rgba(255, 255, 255, 0.84)", align: "flex-start", textAlign: "left", products: productData.slice(0, 5) },
  { id: 2, bannerImg: "/img/editorial/banner-02.png", bannerTitle: "Birthday Cards", bannerDesc: "Sweet, bold and knowingly irreverent ways to mark the day.", bannerBtn: "View cards", sectionTitle: "Birthday Cards", sectionLinkText: "Shop now", boxBg: "rgba(255, 245, 248, 0.9)", align: "center", textAlign: "center", products: productData.slice(5, 10) },
  { id: 3, bannerImg: "/img/editorial/banner-03.png", bannerTitle: "Celebrate your people", bannerDesc: "Colourful pieces for friends who deserve the spotlight.", bannerBtn: "View all", sectionTitle: "Big personality", sectionLinkText: "See all", boxBg: "rgba(255, 255, 255, 0.95)", align: "center", textAlign: "center", products: productData.slice(10, 15) },
  { id: 4, bannerImg: "/img/editorial/banner-04.png", bannerTitle: "Soft characters", bannerDesc: "Original plush companions and a playful hands-free bag.", bannerBtn: "Shop now", sectionTitle: "Soft & playful", sectionLinkText: "Shop all", boxBg: "rgba(255, 255, 255, 0.9)", align: "center", textAlign: "center", products: productData.slice(15, 20) },
  { id: 5, bannerImg: "/img/editorial/banner-05.png", bannerTitle: "Useful can be joyful", bannerDesc: "Kitchen textiles, stickers and stoneware made to be noticed.", bannerBtn: "View all", sectionTitle: "Home colour", sectionLinkText: "Shop now", boxBg: "rgba(255, 255, 255, 0.9)", align: "center", textAlign: "center", products: productData.slice(20, 25) },
];

function Main() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <div className="main"><main>
      {sections.map((section) => (
        <section className={`category-section category-section--${section.id}`} key={section.id}>
          <div className="banner-container">
            <img src={section.bannerImg} alt="" className="banner-bg" />
            <div className="banner-overlay"><div className="banner-overlay-inner">
              <div className="banner-box" style={{ background: section.boxBg, alignItems: section.align, textAlign: section.textAlign }}>
                <h2>{section.bannerTitle}</h2><p>{section.bannerDesc}</p>
                <Link className="banner-button" to="/shop" onClick={toTop}>{section.bannerBtn}</Link>
              </div>
            </div></div>
          </div>
          <div className="section-header"><h3>{section.sectionTitle}</h3><Link to="/shop" onClick={toTop}>{section.sectionLinkText}</Link></div>
          <div className="product-carousel"><div className="product-list">
            {section.products.map((item) => (
              <Link to={`/shopDetails/${item.id}`} className="product-card" key={item.id} onClick={toTop}>
                <div className="image-wrapper"><img src={item.image} alt={item.name} /></div>
                <p className="product-name">{item.name}</p><p className="product-price">{formatMoney(item.price)}</p>
              </Link>
            ))}
          </div></div>
        </section>
      ))}
    </main></div>
  );
}

export default Main;
